import React, { useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { get } from '@/utils/helpers';
import axios from 'axios';
import { API_BASE_URL } from '@/config/serverApiConfig';
import { Select } from 'antd';

const Requestalisting = () => {
  const [categoryOne, setCategoryOne] = useState(null);
  const [categoryTwo, setCategoryTwo] = useState(null);
  const [categoryThree, setCategoryThree] = useState(null);
  const [submitLoader, setSubmitLoader] = useState(false);
  const loaderClose = () => setSubmitLoader(false);

  const [categoryOneError, setCategoryOneError] = useState(false);
  const [categoryTwoError, setCategoryTwoError] = useState(false);


  const [show, setShow] = useState(false);
  const [submitSuccess, setsubmitSuccess] = useState(false);
  const submitSuccessClose = () => setsubmitSuccess(false);
  


  //const [category, setCategory] = useState([]);
  let [dataa, setData] = useState([]);

  let [category, setCategory] = useState([]);
  useEffect(() => {
    axios(`${API_BASE_URL}category/getParent`)
      .then(res => {
        setCategory(res.data.data)

      })
      .catch(err => {
       
      })
  }, []);




  function categoryOneHandler(e) {
    let item = e.target.value;
    
    if (item === "" || item === "Category 1"|| item === undefined|| item === null) {
      setCategoryOneError(true);
    } else {
      setCategoryOneError(false);
      if (categoryThree !== null && categoryTwo === null) {
        setCategoryTwoError(true);

          }
        }
      //  console.log(categoryOne+" "+categoryTwo+" "+categoryThree)

    setCategoryOne(item);
    
  }

  function categoryTwoHandler(e) {

    let item = e.target.value;
    if(categoryOne === null||categoryOne === ""||categoryOne === undefined){
      setCategoryOneError(true);
    }else{
      setCategoryOneError(false);
      setCategoryTwoError(false);
      
    }
    //console.log(categoryOne+" "+categoryTwo+" "+categoryThree)
    setCategoryTwo(item);
    

  }

  function categoryThreeHandler(e) {
    let item = e.target.value;
    if(categoryOne === null||categoryOne === ""||categoryOne === undefined){
      setCategoryOneError(true);
    }else{
      setCategoryOneError(false);
      if(categoryTwo === null||categoryTwo === ""||categoryTwo === undefined){
        setCategoryTwoError(true);
      }
      else{
        setCategoryTwoError(false);
        
      }

    }
    //console.log(categoryOne+" "+categoryTwo+" "+categoryThree)
    setCategoryThree(item);
         }




  async function handleSubmit(e) {
    e.preventDefault();
    
    if (categoryOne == null || categoryOne === "" || categoryOne === "undefined") {
      setCategoryOneError(true);
    }
    else {
      const token = localStorage.getItem("token");

      let formData = new FormData();
      formData.append("category_id_one", categoryOne);
      formData.append("category_id_two", categoryTwo);
      formData.append("category_id_three", categoryThree);

     
     

      axios.post(API_BASE_URL + `request-listing/create`, {
        category_id_one: categoryOne,
        category_id_two: categoryTwo,
        category_id_three: categoryThree,
      },
      {
        headers: {
          'x-access-token': `${token}`
        }
      })
        .then(res => {
          setSubmitLoader(true);
          if (res.status === 200) {
            setSubmitLoader(false);
            setShow(false);
            setsubmitSuccess(true);
            setCategoryOne(null);
            setCategoryTwo(null);
            setCategoryThree(null);
          }
        })
        .catch(err => {
         
        })

    }

  }




  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>


      <Button className='bg-transparent  dash_popup_btn' onClick={handleShow}>
        <svg width="88" height="84" viewBox="0 0 88 84" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1_100)">
            <path className='c-9F7854' d="M0 39.461C0.725963 39.9189 1.46341 40.3424 2.17558 40.8118C9.80585 45.8272 17.4338 50.8472 25.0595 55.8718C25.2709 56.0114 25.473 56.1671 25.7096 56.3297C25.6462 56.4298 25.5739 56.524 25.4937 56.6113C17.1589 64.4717 8.82105 72.3276 0.480138 80.1789C0.330219 80.3041 0.169561 80.416 0 80.5132V39.461Z" fill="#101D42" />
            <path fillRule="evenodd" clipRule="evenodd" d="M71.2498 12.1341H44.0768L16.7222 12.1501C15.0176 12.1524 14.4524 12.7133 14.4524 14.4167C14.4647 23.5745 14.4593 32.7323 14.4363 41.8901C14.4197 42.1522 14.4788 42.4136 14.6067 42.6433C14.7345 42.8729 14.9258 43.0613 15.1577 43.1859C24.5171 49.3232 33.8643 55.4818 43.1992 61.6618C43.8149 62.0625 44.2123 62.0785 44.8418 61.6618C54.1767 55.4849 63.5246 49.327 72.8855 43.1882C73.4438 42.8219 73.6 42.435 73.6 41.8008V14.4922C73.5977 12.6698 73.067 12.1341 71.2498 12.1341Z" fill="#9F7854" />
            <path className='c-9F7854' d="M3.99316 84L30.2013 59.2991C30.4977 59.4799 30.7665 59.6333 31.0238 59.805C34.7777 62.2731 38.5407 64.7319 42.2808 67.2252C43.48 68.0242 44.5942 68.0219 45.7843 67.2252C49.5289 64.7388 53.2874 62.2777 57.0413 59.8073C57.3009 59.6379 57.5651 59.4754 57.866 59.2853L84.0834 84H3.99316Z" fill="#101D42" />
            <path className='c-9F7854' d="M87.9997 80.5819L62.29 56.3526L87.9997 39.4106V80.5819Z" fill="#101D42" />
            <path className='c-9F7854' d="M53.0437 6.92103H35.207C35.2972 6.7786 35.4019 6.64586 35.5195 6.52495C37.9256 4.54076 40.3332 2.55657 42.7423 0.572377C43.5786 -0.114459 44.3505 -0.208326 45.0833 0.391511C47.6839 2.49552 50.2547 4.63158 53.0437 6.92103Z" fill="#101D42" />
            <path className='c-9F7854' d="M78.834 28.1809C81.2462 30.3467 83.5436 32.4072 85.9558 34.5662L78.834 39.2572V28.1809Z" fill="#101D42" />
            <path className='c-9F7854' d="M9.26522 28.158V39.2664L2.11816 34.5684L9.26522 28.158Z" fill="#101D42" />
            <rect x="27" y="24" width="33" height="3" rx="1.5" fill="white" />
            <rect x="27" y="31" width="33" height="3" rx="1.5" fill="white" />
            <rect x="27" y="38" width="33" height="3" rx="1.5" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_1_100">
              <rect width="88" height="84" fill="white" />
            </clipPath>
          </defs>
        </svg><span className='dash_btn_text'>Request a <strong>listing</strong></span>
      </Button>


      <Modal show={show} onHide={handleClose} className="ListaBusiness dash_popup_same">
        <Modal.Header closeButton className='p-0'>
          <Modal.Title className='d-flex align-content-center'><svg width="42" height="40" viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_113_498)">
              <path d="M0 18.791C0.346482 19.009 0.698444 19.2107 1.03835 19.4342C4.68007 21.8225 8.32069 24.213 11.9602 26.6056C12.0611 26.6721 12.1576 26.7463 12.2705 26.8237C12.2402 26.8713 12.2057 26.9162 12.1674 26.9578C8.18948 30.7008 4.21005 34.4417 0.229157 38.1804C0.157605 38.2401 0.0809268 38.2933 0 38.3396V18.791Z" fill="#101D42" />
              <path fillRule="evenodd" clipRule="evenodd" d="M34.0055 5.77814H21.0365L7.98097 5.78577C7.1674 5.78686 6.89767 6.05396 6.89767 6.86508C6.90352 11.2259 6.90095 15.5868 6.88999 19.9477C6.88204 20.0725 6.91025 20.1969 6.97127 20.3063C7.03229 20.4157 7.12357 20.5054 7.23428 20.5647C11.7013 23.4872 16.1624 26.4199 20.6177 29.3628C20.9116 29.5536 21.1012 29.5612 21.4017 29.3628C25.857 26.4214 30.3185 23.489 34.7862 20.5658C35.0526 20.3914 35.1272 20.2071 35.1272 19.9051V6.90106C35.1261 6.03325 34.8728 5.77814 34.0055 5.77814Z" fill="#9F7854" />
              <path d="M1.90576 40L14.4142 28.2377C14.5557 28.3238 14.6839 28.3969 14.8067 28.4786C16.5984 29.6539 18.3944 30.8248 20.1794 32.012C20.7518 32.3925 21.2835 32.3914 21.8515 32.012C23.6387 30.828 25.4326 29.6561 27.2242 28.4797C27.3481 28.399 27.4742 28.3216 27.6178 28.2311L40.1306 40H1.90576Z" fill="#101D42" />
              <path d="M42 38.3723L29.7295 26.8346L42 18.767V38.3723Z" fill="#101D42" />
              <path d="M25.3162 3.29574H16.8032C16.8462 3.22791 16.8962 3.16471 16.9523 3.10713C18.1007 2.16228 19.2498 1.21742 20.3996 0.272569C20.7987 -0.0544953 21.1671 -0.0991941 21.5169 0.186442C22.7581 1.18835 23.985 2.20552 25.3162 3.29574Z" fill="#101D42" />
              <path d="M37.6255 13.4195C38.7768 14.4508 39.8732 15.432 41.0245 16.4601L37.6255 18.694V13.4195Z" fill="#101D42" />
              <path d="M4.42184 13.4086V18.6983L1.01074 16.4612L4.42184 13.4086Z" fill="#101D42" />
              <rect x="13.2383" y="11.1115" width="15.5248" height="1.74536" rx="0.87268" fill="white" />
              <rect x="13.2383" y="15.184" width="15.5248" height="1.74536" rx="0.87268" fill="white" />
              <rect x="13.2383" y="19.2565" width="15.5248" height="1.74536" rx="0.87268" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_113_498">
                <rect width="42" height="40" fill="white" />
              </clipPath>
            </defs>
          </svg>

            <h4 className='h2_medum mb-0 ps-2'>REQUEST A<span className='color-9F7854 user-name fw-bold'> BUSINESS LISTING</span></h4></Modal.Title>
        </Modal.Header>
        <p>Please select up to 3 business categories to receive the business listing(s) via email after admin approval.</p>
        <Modal.Body className='p-0'>
          <Row className='mb-4'>
            <Col>
              <form onSubmit={handleSubmit}>
                <Form.Label>Select Your Category <span className='req'>*</span></Form.Label>
                <Form.Select onChange={categoryOneHandler} type="text" className='border-0 border-bottom bg-transparent mb-3' defaultValue="Choose..."  >
                  <option>Category 1</option>
                  {category.filter(catOne => catOne.isParent === true && catOne._id != categoryTwo && catOne._id != categoryThree).map((value, index) => {
                   
                    return <option value={value._id} key={value._id} >{value.name}</option>
                  })}
                </Form.Select>
                
                <Form.Select onChange={categoryTwoHandler} type="text" className='border-0 border-bottom bg-transparent mb-3' defaultValue="Choose...">
                  <option>Category 2</option>
                  {
                  // if categoryone is not empty then will not map please select category one
                  //categoryOne !== "" ? "" : category.filter(cat => cat.isParent === true && cat._id != categoryOne && cat._id != categoryThree).map((value, index) => {
                  category.filter(catTwo =>catTwo._id != categoryOne && catTwo._id != categoryThree && catTwo.isParent === true).map((value, index) => {
                   
                    return <option value={value._id} key={value._id} >{value.name} </option>
                  })}
                </Form.Select>
                
                <Form.Select onChange={categoryThreeHandler} type="text" className='border-0 border-bottom bg-transparent mb-3' defaultValue="Choose...">
                  <option>Category 3</option>
                  {category.filter(cat =>cat._id != categoryOne && cat._id != categoryTwo && cat.isParent === true).map((value, index) => {
                     
                    return <option value={value._id} key={value._id} >{value.name}</option>

                  })}
                </Form.Select>
                
                {categoryOneError ? <span className="error-msg">Category one is required</span> : ""}

                <div className='float-end'>

                  <Modal show={submitLoader} onHide={loaderClose} >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </Modal>
                  <Button className='btn-full-color' onClick={handleSubmit} type="submit">
                    Submit
                  </Button>
                </div>
              </form>
            </Col>
          </Row>

        </Modal.Body>
      </Modal>

      <Modal show={submitSuccess} onHide={submitSuccessClose} className='SubmitPopup'>
        <Modal.Header closeButton className='border-0'></Modal.Header>
        <Modal.Body className='text-center py-5'>
          <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_113_322)">
              <path d="M42.2982 73.7798C61.5168 71.7083 75.4184 54.4594 73.3482 35.2533C71.278 16.0473 54.02 2.15707 34.8014 4.22862C15.5827 6.30017 1.68115 23.5491 3.75134 42.7551C5.82154 61.9611 23.0795 75.8514 42.2982 73.7798Z" fill="#9F7854" />
              <path d="M33.4835 57.1484L18.8401 42.1276L24.3222 36.7842L33.3144 46.0081L53.2186 24.3097L58.8613 29.4841L33.4835 57.1484Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_113_322">
                <rect width="70" height="70" fill="white" transform="translate(0 7.95245) rotate(-6.15208)" />
              </clipPath>
            </defs>
          </svg>
          <p className='pb-3 pt-3'>Your request is submitted and under review.</p>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default Requestalisting;

